<template>
  <div class="edit-video-box">
    <el-dialog
      class="game-dialog"
      :title="'VIP权益'"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false">
      <el-form>
          <el-form-item v-if="vipInfo.vipExpireDate">
           会员到期时间至:
           <span style="margin-left: 20px;">
              {{ vipInfo.vipExpireDate | changeDate }}
           </span>
          </el-form-item>
          <el-form-item v-if="vipInfo.goldVideoFreeExpire">
           金币短视频免费观看至:
           <span style="margin-left: 20px;">
              {{ vipInfo.goldVideoFreeExpire | changeDate }}
           </span>
          </el-form-item>
          <el-form-item v-if="vipInfo.payVidDiscount > 0">
            金币视频购买折扣:
            <span style="margin-left: 20px;">
              {{ vipInfo.payVidDiscount  }} 折
            </span>
          </el-form-item>
          <el-form-item v-if="vipInfo.videoDiscount && vipInfo.videoDiscountExpiration">
            {{ vipInfo.videoDiscount  }} 折视频折扣卡有效期至:
            <span style="margin-left: 20px;">
              {{ vipInfo.videoDiscountExpiration | changeDate  }}
            </span>
          </el-form-item>
          <el-form-item v-if="vipInfo.videoFreeExpiration">
            30金币视频免费看有效期至:
            <span style="margin-left: 20px;">
              {{ vipInfo.videoFreeExpiration | changeDate  }}
            </span>
          </el-form-item>
          <el-form-item v-if="vipInfo.louFengDiscount > 0">
            全场楼凤购买折扣:
            <span style="margin-left: 20px;">
              {{ (100-vipInfo.louFengDiscount)/10  }} 折
            </span>
          </el-form-item>
          <el-form-item v-if="vipInfo.louFengQmExpiration">
            全场楼凤全面至:
            <span style="margin-left: 20px;">
              {{ vipInfo.louFengQmExpiration | changeDate }}
            </span>
          </el-form-item>
          <el-form-item v-if="vipInfo.louFengUnlockTimes">
            全场楼凤解锁次数:
            <span style="margin-left: 20px;">
              {{ vipInfo.louFengUnlockTimes }} 次
            </span>
          </el-form-item>
          <el-form-item v-if="vipInfo.goldVideoCoupon">
            <ul>
              <li v-for="item in vipInfo.goldVideoCoupon" :key="item">
                {{ item.gold }}金币观影券: {{ item.count }}张
              </li>
            </ul>
          </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      uid: "",
      dialogVisible: false,
      vipInfo: {}
    };
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.vipInfo = {};
    },
    // 提交修改
    getVipInfo() {
      let params = {
        uid: this.uid,
      };
      API.getUserVipInfo(params)
        .then((res) => {
          if (res.code === 200) {
            this.vipInfo = res.data;
          } else {
            this.$message.error("查询VIP权益失败");
          }
        })
        .catch(() => {
        });
    },
    // 打开弹窗、传递需要编辑的参数
    open(row) {
      this.uid = row.uid;
      this.getVipInfo();
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-input {
    width: 150px;
  }
}
.form_item {
  display: flex;
}
.game-dialog {
  .el-dialog__body {
    padding: 25px 25px 0 !important;
  }
}
.el-form-item__content {
  margin-left: 0px !important;
}
</style>
